import React from 'react';
import { Row, Container, Col } from "react-bootstrap";
import {
  BuildIcon,
  DesignIcon,
  LaunchIcon,
  MaintenanceIcon,
  PlaneIcon,
  TestIcon,
} from "../../../app-constants";
const WorkFlow = [
  {
    logo: PlaneIcon,
    title: "Plan",
    description:
      "We utilize scrum methodologies to develop a path for development prioritizing items from the backlog.",
    count: "01",
  },
  {
    logo: DesignIcon,
    title: "Design",
    description:
      "We create a user-friendly and visually pleasing user interface in this phase.",
    count: "02",
  },
  {
    logo: BuildIcon,
    title: "Build",
    description:
      "Our developers transform the design into a functional prototype app, web, or software leveraging modern tech-stack.",
    count: "03",
  },
  {
    logo: TestIcon,
    title: "Test",
    description:
      "To guarantee your app works perfectly, robust testing is conducted to classify and rectify any bugs.",
    count: "04",
  },
  {
    logo: LaunchIcon,
    title: "Launch",
    description:
      "Your prototype is ready to make its debut, available to the intended target audience.",
    count: "05",
  },
  {
    logo: MaintenanceIcon,
    title: "Maintenance",
    description:
      "We offer ongoing support and updates to keep your prototype up-to-date and responsive to all requirements.",
    count: "06",
  },
];
const Workflow = () => {
  return (
    <div className="workflow p-100 tekrevol_gray_bg">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
            Our Startup Prototype Development <span>Workflow</span>
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <p>
            Start your transformative journey with our Startup Prototype Development Workflow. We precisely conceive ideas, design, and iterate, warranting your vision nurtures into a robust prototype. From inception of the idea to enhancement, our agile process assures innovation, precision, and a flawless transition from idea to a market-ready prototype.</p>
          </Col>
        </Row>
        <Row className="workflow_secion">
          {WorkFlow.map((item, index) => (
            <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="my-auto">
              <div className="workflow_items">
                <div className="item_name">
                  <span>{item.count}</span>
                  {item.title}
                  <div className="item_icon"> {item.logo}</div>
                </div>
                <p>{item.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default Workflow;
